<div class="w-12"
     [class]="(data.boxBackgroundColor || 'bg-col-t') + ' ' + (data.textColor || 'col-1') + ' ' + (boxTextAlign || '')">
    <p class="o1 uppercase"
       *iCms="'overlineText' of data; skipEmpty:true"></p>
    <div class="inline-flex"
         style="gap: 4px; flex-direction: column">
        @if(data.icon){
        <i [class]="data.icon"
           [style.fontSize.px]="[52, 52, 56, 56][client.sizeId]"></i>
        }
        <!-- default tag is h2, not h3: pages carry a single h1, so h3 here
             skipped a level. Visual size comes from titleStyle, not the tag. -->
        <div class="m-t-1"
             [class]="data.titleStyle || 'h1'"
             *iCms="'title' of data; tag: data.titleTag || 'h2'"></div>
    </div>
    <div class="m-t-2"
         [class]="data.subtitleStyle || 'p1'"
         *iCms="'subtitle' of data; skipEmpty: true; content: 'html'"></div>
    <div class="flex flex-middle flex-wrap"
         [class.m-t]="data.buttons?.length"
         [style.gap.px]="8"
         [class]="boxTextAlign === 'center' ? 'flex-justify-center' : boxTextAlign === 'right' ? 'flex-justify-end' : ''">
        @for (button of data.buttons; track $index) {
        @if (button) {
        <href [link]="button.link">
            <span [buttonStyle]="button.style">
                <span *iCms="'copy' of button;"></span>
            </span>
        </href>
        }
        }
    </div>
</div>